// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchtxtbtn {
  color: white !important;
  font-weight: bold !important;
}

.searchtxtbtnbgcolor {
  background-color: #17a0b4 !important;
}

.maticongray {
  color: rgba(125, 125, 125, 0.768627451);
}

.background-highlight {
  background: #ccd5de;
  color: #fff;
}

.search_style {
  width: 100%;
  float: right;
  margin: 0;
  border: none;
  box-shadow: rgba(99, 99, 99, 0.2) 1px 1px 5px 4px;
  border-radius: 11px;
}

.search_text_control {
  border-top-left-radius: 8px;
  border: none;
  border-right: 1px solid lightgrey;
  border-bottom-left-radius: 8px;
}

.search_btn_style {
  background-color: #ffffff !important;
  border: none;
  width: 16%;
  margin-block: 4px;
}

.search-box,
.close-icon,
.search-wrapper {
  position: relative;
  padding: 0px;
}

.search-wrapper {
  width: 500px;
  margin: auto;
  margin-top: 50px;
}

.search-box {
  width: 80%;
  border: 1px solid #ccc;
  outline: 0;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 15px;
  border-top-right-radius: 0px;
  border-top-left-radius: 15px;
}

.close-icon {
  border: 1px solid transparent;
  background-color: transparent;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}

.close-icon:after {
  content: "X";
  display: block;
  /* width: 15px; */
  /* height: 15px; */
  position: absolute;
  /* background-color: #FA9595; */
  z-index: 1;
  right: 7px;
  top: 0;
  bottom: 0;
  margin: auto;
  /* padding: 2px; */
  border-radius: 50%;
  text-align: center;
  /* color: white; */
  font-weight: normal;
  font-size: 22px;
  /* box-shadow: 0 0 2px #e50f0f; */
  cursor: pointer;
}

.search-box:not(:valid) ~ .close-icon {
  display: none;
}

.treenode-alignment {
  padding-left: 120px;
  width: max-content;
  padding-right: 6% !important;
}

.w700_fontsize {
  font-size: 12px !important;
}

.text3dots {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.node_foldername {
  min-width: 20px;
  max-width: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  padding-left: 4px;
  padding-top: 1px;
}

.mat-tree-div {
  height: 440px;
  overflow: auto;
}

.mat-tree-node {
  height: 24px;
}

.history_search {
  position: relative;
}

.filehistory_div {
  height: 27px;
  display: inline-block;
  overflow-x: auto;
  width: 70%;
  overflow-y: hidden;
  white-space: nowrap;
  margin-inline-end: 1%;
}

.filehistory_span {
  font-size: 16px;
  margin-bottom: 1%;
  cursor: pointer;
  flex-shrink: 0;
}

.search_div {
  width: 30%;
  height: 15px;
  display: inline-block;
  position: absolute;
}

.input-group .form-control {
  flex: 0 1 auto !important;
  width: 1%;
}

.input_div {
  border: 1px #c8c9ca solid;
  border-radius: 50px;
}

.search_icon {
  margin-top: 2%;
  margin-left: 3%;
}

.input_search {
  border: 0;
  box-shadow: none !important;
  outline: none !important;
  width: 89% !important;
  display: block;
}

.foldername_span {
  display: -webkit-box;
  font-size: 13px;
  line-height: 1.4;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.folder_view_div {
  overflow-x: hidden;
  overflow-y: auto;
}

.folder_view_span {
  display: inline-block;
  min-height: 100px;
  text-align: center;
}

.lastModifiedDate {
  font-size: 12px;
  color: rgb(143, 140, 140);
}

.listViewhead {
  background-color: whitesmoke;
}

.listViewbody {
  overflow-x: hidden;
  overflow-y: auto;
}

.listViewfoldernames {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.folderempty_div {
  display: flex;
}

.folderempty_p {
  margin: auto;
}

.filexplorer_footer {
  background-color: white;
  display: flex;
  justify-content: normal;
}

.items_span {
  position: relative;
  top: 4px;
}

.modal_width {
  margin: 10px 30px !important;
}

.modal-dialog {
  max-width: 100%;
  max-height: 60%;
  height: 60%;
  margin: auto;
  padding: 0 !important;
}

.moveIcon {
  height: 16px;
  width: 16px;
  color: #fff !important;
}

.path_arrow {
  height: 23px;
  width: 21px;
  font-size: 23px;
  position: relative;
  top: 6%;
  left: 1.5px;
}

::ng-deep .selectvalue {
  height: 27px;
  line-height: 11px;
}

.text_bold {
  font-weight: 600 !important;
}

::ng-deep.scrollpdf .ng2-pdf-viewer-container {
  overflow: unset !important;
  position: absolute;
  height: 100%;
}

.isView {
  color: #00478e;
  font-weight: 600;
}

.header_label {
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

::ng-deep.filelist.mat-mdc-checkbox .mdc-checkbox {
  width: 14px;
  height: 14px;
  padding-inline: 6px;
  padding-block: 3px;
  bottom: 8px;
}
::ng-deep.filelist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__ripple {
  display: none;
}
::ng-deep.filelist.mat-mdc-checkbox .mdc-checkbox .mat-mdc-checkbox-ripple {
  display: none;
}
::ng-deep.filelist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #17a0b4 !important;
  background-color: #17a0b4 !important;
}
::ng-deep.filelist.mat-mdc-checkbox .mdc-checkbox .mdc-checkbox__native-control:enabled ~ .mdc-checkbox__background .mdc-checkbox__checkmark {
  color: white;
}
::ng-deep.filelist.mat-mdc-checkbox .mdc-checkbox__background {
  height: 16px !important;
  width: 16px !important;
}

::ng-deep.mattreebtn .mat-mdc-button-persistent-ripple {
  width: 40% !important;
  display: none !important;
}
::ng-deep.mattreebtn .mat-mdc-focus-indicator {
  width: 40% !important;
  display: none !important;
}
::ng-deep.mattreebtn .mat-mdc-button-touch-target {
  left: 20% !important;
  display: none !important;
}
::ng-deep.mattreebtn .mat-ripple {
  width: 40% !important;
  display: none !important;
}

.matreefol {
  height: 18px !important;
  width: 18px !important;
  float: left !important;
  position: relative !important;
  top: 10% !important;
}

::ng-deep.myCustomModalClassFTPHL7 .modal-dialog {
  max-width: 97%;
  max-height: 60%;
  height: 60%;
  margin-block: 0px !important;
  margin: auto;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/ftpfiles/ftpfiles.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAIA;EACE,uBAAA;EACA,4BAAA;AAHF;;AAKA;EACE,oCAAA;AAFF;;AAKA;EACE,uCAAA;AAFF;;AAKA;EACE,mBAAA;EACA,WAAA;AAFF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,iDAAA;EACA,mBAAA;AADF;;AAIA;EACE,2BAAA;EACA,YAAA;EACA,iCAAA;EACA,8BAAA;AADF;;AAIA;EACE,oCAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;AADF;;AAMA;;;EAGE,kBAAA;EACA,YAAA;AAHF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAFF;;AAIA;EACE,UAAA;EACA,sBAAA;EACA,UAAA;EAEA,+BAAA;EACA,+BAAA;EACA,4BAAA;EACA,4BAAA;AAFF;;AAKA;EACE,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;AAFF;;AAIA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;EACA,eAAA;AADF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,4BAAA;AAAF;;AAGA;EACE,0BC1GS;AD0GX;;AAEA;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAKA;EACE,aAAA;EACA,cAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EAEA,qBAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,UAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,SAAA;AAFF;;AAKA;EACE,yBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,SAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;EACA,cAAA;AAFF;;AAKA;EACE,oBAAA;EAEA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,qBAAA;EACF,iBAAA;EACE,kBAAA;AAHF;;AAOA;EACE,eAAA;EACA,yBAAA;AAJF;;AAMA;EACE,4BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AAHF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,uBAAA;EACA,aAAA;EACA,uBAAA;AAFF;;AAIA;EACE,kBAAA;EACA,QAAA;AADF;;AAIA;EAEE,4BAAA;AAFF;;AAMA;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AAHF;;AAMA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;AAHF;;AASA;EACE,YAAA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;AANJ;;AAUA;EACE,YAAA;EACA,iBAAA;AAPF;;AAWA;EACE,2BAAA;AARF;;AAWA;EACE,0BAAA;EACA,kBAAA;EACA,YAAA;AARF;;AAYA;EACE,cAAA;EACA,gBAAA;AATF;;AAaA;EACI,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAVJ;;AAcE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAXJ;AAYI;EACE,aAAA;AAVN;AAYI;EACE,aAAA;AAVN;AAYI;EACE,gCCvUM;EDwUN,oCCxUM;AD8TZ;AAYI;EACE,YAAA;AAVN;AAaE;EACE,uBAAA;EACA,sBAAA;AAXJ;;AAgBE;EACE,qBAAA;EACA,wBAAA;AAbJ;AAeE;EACE,qBAAA;EACA,wBAAA;AAbJ;AAeE;EACE,oBAAA;EACA,wBAAA;AAbJ;AAeE;EACE,qBAAA;EACA,wBAAA;AAbJ;;AAgBA;EACI,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAbJ;;AAeA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,qBAAA;AAZF","sourcesContent":["@import \"../../variables.scss\";\r\n\r\n\r\n\r\n.searchtxtbtn {\r\n  color: white !important;\r\n  font-weight: bold !important;\r\n}\r\n.searchtxtbtnbgcolor {\r\n  background-color: #17a0b4 !important;\r\n}\r\n\r\n.maticongray {\r\n  color: #7d7d7dc4;\r\n}\r\n\r\n.background-highlight {\r\n  background: #ccd5de;\r\n  color: #fff;\r\n}\r\n.search_style {\r\n  width: 100%;\r\n  float: right;\r\n  margin: 0;\r\n  border: none;\r\n  box-shadow: rgb(99 99 99 / 20%) 1px 1px 5px 4px;\r\n  border-radius: 11px;\r\n}\r\n\r\n.search_text_control {\r\n  border-top-left-radius: 8px;\r\n  border: none;\r\n  border-right: 1px solid lightgrey;\r\n  border-bottom-left-radius: 8px;\r\n}\r\n\r\n.search_btn_style {\r\n  background-color: #ffffff !important;\r\n  border: none;\r\n  width: 16%;\r\n  margin-block: 4px;\r\n}\r\n\r\n////seach box with icon\r\n\r\n.search-box,\r\n.close-icon,\r\n.search-wrapper {\r\n  position: relative;\r\n  padding: 0px;\r\n}\r\n.search-wrapper {\r\n  width: 500px;\r\n  margin: auto;\r\n  margin-top: 50px;\r\n}\r\n.search-box {\r\n  width: 80%;\r\n  border: 1px solid #ccc;\r\n  outline: 0;\r\n  // border-radius: 15px;\r\n  border-bottom-right-radius: 0px;\r\n  border-bottom-left-radius: 15px;\r\n  border-top-right-radius: 0px;\r\n  border-top-left-radius: 15px;\r\n}\r\n\r\n.close-icon {\r\n  border: 1px solid transparent;\r\n  background-color: transparent;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  outline: 0;\r\n  cursor: pointer;\r\n}\r\n.close-icon:after {\r\n  content: \"X\";\r\n  display: block;\r\n  /* width: 15px; */\r\n  /* height: 15px; */\r\n  position: absolute;\r\n  /* background-color: #FA9595; */\r\n  z-index: 1;\r\n  right: 7px;\r\n  top: 0;\r\n  bottom: 0;\r\n  margin: auto;\r\n  /* padding: 2px; */\r\n  border-radius: 50%;\r\n  text-align: center;\r\n  /* color: white; */\r\n  font-weight: normal;\r\n  font-size: 22px;\r\n  /* box-shadow: 0 0 2px #e50f0f; */\r\n  cursor: pointer;\r\n}\r\n.search-box:not(:valid) ~ .close-icon {\r\n  display: none;\r\n}\r\n\r\n.treenode-alignment {\r\n  padding-left: 120px;\r\n  width: max-content;\r\n  padding-right: 6% !important;\r\n}\r\n\r\n.w700_fontsize {\r\n  font-size: $fontsize;\r\n}\r\n.text3dots {\r\n  position: relative;\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n\r\n.node_foldername {\r\n  min-width: 20px;\r\n  max-width: 110px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  padding-left: 4px;\r\n  padding-top: 1px;\r\n  \r\n}\r\n\r\n\r\n.mat-tree-div {\r\n  height: 440px;\r\n  overflow: auto\r\n}\r\n\r\n.mat-tree-node {\r\n  height: 24px;\r\n}\r\n.history_search {\r\n  position: relative;\r\n}\r\n\r\n.filehistory_div {\r\n  height: 27px;\r\n  display: inline-block;\r\n  overflow-x: auto;\r\n  width: 70%;\r\n  overflow-y: hidden;\r\n  white-space: nowrap;\r\n  // font-weight: 600;\r\n  margin-inline-end: 1%;\r\n}\r\n\r\n.filehistory_span {\r\n  font-size: 16px;\r\n  margin-bottom: 1%;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.search_div {\r\n  width: 30%;\r\n  height: 15px;\r\n  display: inline-block;\r\n  position: absolute;\r\n}\r\n\r\n.input-group .form-control {\r\n  flex: 0 1 auto !important;\r\n  width: 1%;\r\n}\r\n\r\n.input_div {\r\n  border: 1px #c8c9ca solid;\r\n  border-radius: 50px;\r\n}\r\n\r\n.search_icon {\r\n  margin-top: 2%;\r\n  margin-left: 3%;\r\n}\r\n\r\n.input_search {\r\n  border: 0;\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n  width: 89% !important;\r\n  display: block;\r\n}\r\n\r\n.foldername_span {\r\n  display: -webkit-box;\r\n  // max-width: 100px;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  -webkit-line-clamp: 1;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.folder_view_div {\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.folder_view_span {\r\n  display: inline-block;\r\nmin-height: 100px;\r\n  text-align: center;\r\n  // height: 200px;\r\n}\r\n\r\n.lastModifiedDate {\r\n  font-size: 12px;\r\n  color: rgb(143, 140, 140);\r\n}\r\n.listViewhead {\r\n  background-color: whitesmoke;\r\n}\r\n\r\n.listViewbody {\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.listViewfoldernames {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.folderempty_div {\r\n  display: flex;\r\n}\r\n\r\n.folderempty_p {\r\n  margin: auto;\r\n}\r\n\r\n.filexplorer_footer {\r\n  background-color: white;\r\n  display: flex;\r\n  justify-content: normal;}\r\n\r\n.items_span {\r\n  position: relative;\r\n  top: 4px;\r\n}\r\n\r\n.modal_width {\r\n  //max-width: 95vw !important;\r\n  margin: 10px 30px !important;\r\n\r\n}\r\n\r\n.modal-dialog {\r\n  max-width: 100%;\r\n  max-height: 60%;\r\n  height: 60%;\r\n  margin: auto;\r\n  padding: 0 !important;\r\n}\r\n\r\n.moveIcon{\r\n  height: 16px;\r\n  width: 16px;\r\n  color: #fff !important;\r\n}\r\n\r\n\r\n\r\n\r\n.path_arrow{\r\n  height: 23px;\r\n    width: 21px;\r\n    font-size: 23px;\r\n    position: relative;\r\n    top: 6%;\r\n    left: 1.5px;\r\n}\r\n\r\n\r\n::ng-deep .selectvalue {\r\n  height: 27px;\r\n  line-height: 11px;\r\n}\r\n\r\n\r\n.text_bold {\r\n  font-weight: 600 !important;\r\n}\r\n\r\n::ng-deep.scrollpdf .ng2-pdf-viewer-container {\r\n  overflow: unset !important;\r\n  position: absolute;\r\n  height: 100%;\r\n}\r\n\r\n\r\n.isView{\r\n  color: #00478e;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.header_label{\r\n    display: inline-block;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow-x: hidden;\r\n}\r\n\r\n::ng-deep.filelist.mat-mdc-checkbox {\r\n  .mdc-checkbox {\r\n    width: 14px;\r\n    height: 14px;\r\n    padding-inline: 6px;\r\n    padding-block: 3px;\r\n    bottom: 8px;\r\n    .mdc-checkbox__ripple{\r\n      display: none;\r\n    }\r\n    .mat-mdc-checkbox-ripple{\r\n      display: none;\r\n    }\r\n    .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background{\r\n      border-color: $btn-color;\r\n      background-color: $btn-color;\r\n    }\r\n    .mdc-checkbox__native-control:enabled~.mdc-checkbox__background .mdc-checkbox__checkmark {\r\n      color: white;\r\n  }\r\n  }\r\n  .mdc-checkbox__background{\r\n    height: 16px !important;\r\n    width: 16px !important;\r\n  }\r\n}\r\n\r\n::ng-deep.mattreebtn{\r\n  .mat-mdc-button-persistent-ripple{\r\n    width: 40% !important;\r\n    display: none !important;\r\n  }\r\n  .mat-mdc-focus-indicator{\r\n    width: 40% !important;\r\n    display: none !important;\r\n  }\r\n  .mat-mdc-button-touch-target{\r\n    left: 20% !important;\r\n    display: none !important;\r\n  }\r\n  .mat-ripple{\r\n    width: 40% !important;\r\n    display: none !important;\r\n  }\r\n}\r\n.matreefol{\r\n    height: 18px !important;\r\n    width: 18px !important;\r\n    float: left !important;\r\n    position: relative !important;\r\n    top: 10% !important;\r\n}\r\n::ng-deep.myCustomModalClassFTPHL7 .modal-dialog {\r\n  max-width: 97%;\r\n  max-height: 60%;\r\n  height: 60%;\r\n  margin-block: 0px !important;\r\n  margin: auto;\r\n  padding: 0 !important;\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
